import { render, staticRenderFns } from "./reainfadi.vue?vue&type=template&id=21a1b383&scoped=true"
import script from "./reainfadi.vue?vue&type=script&lang=js"
export * from "./reainfadi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a1b383",
  null
  
)

export default component.exports